import { render } from "./ContractorsList.vue?vue&type=template&id=623451c0&scoped=true"
import script from "./ContractorsList.vue?vue&type=script&lang=js"
export * from "./ContractorsList.vue?vue&type=script&lang=js"

import "./ContractorsList.vue?vue&type=style&index=0&id=623451c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623451c0"]])

export default __exports__